import { Vue, Component, Prop } from 'vue-property-decorator'
import { VBtn, VCard, VCardText, VDialog, VIcon, VImg, VRow, VSpacer } from 'vuetify/lib'
import './GenericModal.scss'

@Component({})
export class GenericModal extends Vue {
	@Prop({ type: String, required: false }) title!: string
	@Prop({ type: String, required: false }) description!: string
	@Prop({ type: String, required: false, default: 'OK, entendi' }) textButton!: string
	@Prop({ type: String, required: false, default: '' }) cancelButton!: string
	@Prop({ type: String, required: false }) image!: string
	@Prop({ type: String, required: false }) icon!: string
	openModal = false

	public render() {
		return (
			<VDialog
				class="fade-in"
				clipped
				fixed
				right
				temporary
				width="438"
				height="573"
				vModel={this.openModal}
				on={{ 'click:outside': () => this.close() }}
			>
				<VCard id="app-generic-modal" class="pa-10 justify-center" align="center">
					<VRow class="d-flex">
						<VSpacer />
						<VBtn small color="#4D4D4D" icon fab onClick={() => (this.openModal = false)}>
							<VIcon>mdi-close</VIcon>
						</VBtn>
					</VRow>
					{this.image && <VImg align="center" justify-center contain class="mx-auto" src={this.image} cover width="246" height="261" />}
					{this.icon && (
						<VIcon x-large class="mx-auto">
							{this.icon}
						</VIcon>
					)}
					<h2 class="text-center pb-2 mt-5 app-modal-title">{this.title}</h2>

					<VCardText class="text-center app-modal-subtitle" domPropsInnerHTML={this.description} />
					<VBtn block class="mt-5" depressed color="primary" onClick={() => this.close()}>
						{this.textButton}
					</VBtn>
					{this.cancelButton.length > 0 && (
						<VBtn block class="mt-5" depressed outlined color="primary" onClick={() => (this.openModal = false)}>
							{this.cancelButton}
						</VBtn>
					)}
				</VCard>
			</VDialog>
		)
	}

	open() {
		this.openModal = true
	}

	close() {
		this.$emit('closeModal')
		this.openModal = false
	}
}

export default GenericModal
